import { Stack, Typography } from '@mui/material';

import { MinimalTarget } from '@/generated/model';
import { inactiveTargetStates } from '@/tmp/Target';

import './TargetNameAndDescription.css';

// eslint-disable-next-line react-refresh/only-export-components
export function targetNameAndDescriptionStyle(
  selected: boolean | undefined,
  hasStatus: boolean | undefined,
  inactive: boolean = false
): StyleClassName {
  switch (selected) {
    case true:
      switch (hasStatus) {
        case false:
          return 'target-name-and-description-selected-nostatus';
        case true:
        case undefined:
          return 'target-name-and-description-selected';
      }
      break;
    case false:
      if (inactive) {
        return 'target-name-and-description-inactive';
      }
      return 'target-name-and-description-nonselected';
    case undefined:
      return 'target-name-and-description-header';
  }
}

// eslint-disable-next-line react-refresh/only-export-components
export function isTargetInactiveByState(target: MinimalTarget) {
  return inactiveTargetStates.includes(target.state);
}

type StyleClassName =
  | 'target-name-and-description-selected-nostatus'
  | 'target-name-and-description-selected'
  | 'target-name-and-description-inactive'
  | 'target-name-and-description-nonselected'
  | 'target-name-and-description-header';

export function TargetNameAndDescription({
  targetName,
  targetDescription,
  styleClassName,
}: {
  targetName: string | undefined;
  targetDescription: string | undefined;
  styleClassName: StyleClassName;
}) {
  const isHeader = styleClassName === 'target-name-and-description-header';
  return (
    <Stack
      sx={{
        justifyContent: 'center',
        textAlign: 'start',
        overflowWrap: 'break-word',
        ...(isHeader && { justifyContent: 'flex-start' }),
      }}
      className={styleClassName}
    >
      <Typography variant={isHeader ? 'h6' : 'body2'} data-qa-element-id="target_name">
        {targetName}
      </Typography>
      <Typography
        variant={isHeader ? 'subtitle2' : 'helperText'}
        className="target-name-and-description-description"
        data-qa-element-id="target_description"
      >
        {targetDescription}
      </Typography>
    </Stack>
  );
}
